<template>
    <div id="OwlWarranty">
        <div class="admin-content-area">
            <div class="container-fluid xyz">
                <div id="page-content-wrapper" class="admin-page-content">
                    <section class="internal-container">
                        <div class="container">
                            <!-- <div class="row"> -->
                                <iframe ref="myframe" id="fb_iframe" src="https://secure.freightliner.com/iwarranty/servlet/com.fourcs.clm.iwarranty.eclaims.dataview.servlets.WarrantyDetailsGoToServlet" height="1000px;"  title="" width="1000px;"></iframe>
                            <!-- </div> -->
                        </div>
                    </section>
                </div>
               
            </div>
             <app-footer></app-footer>
        </div>
    </div>            
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
    name:"OwlWarranty",
    
    mixins:[commonMixins],
    data: () => ({

    }),

    created: function() {

    },
    beforeDestroy(){
    },
    mounted: function() {

        var self = this;

        self.getPermissions();
        // setTimeout(function(){
        window.onload = function() {
        // Get the window displayed in the iframe.
        var receiver = document.getElementById('fb_iframe').contentWindow;

        // Get a reference to the 'Send Message' button.
        // var btn = document.getElementById('send');

        // A function to handle sending messages.
            function sendMessage(e) {
                // Prevent any default browser behaviour.
                e.preventDefault();

                // Send a message with the text 'Hello Treehouse!' to the receiver window.
                receiver.postMessage('Hello!', 'https://chec-dtna.prd.freightliner.com/smlogin/FTLloginPWC.fcc?TYPE=100728833&REALMOID=06-6a59952c-05ca-1163-a514-83e23d730cb3&GUID=&SMAUTHREASON=0&METHOD=POST&SMAGENTNAME=$SM$dCB7PY7fbmne6Mk8HqsIp5%2fbP%2bGnk1OSGgte6WNTbltYpsl1jY0lJ5PE%2frfjMKNNUhEW8uf3kNWdDLBv7FjyFoc1bFwJUZyI&TARGET=$SM$https%3a%2f%2fsecure%2efreightliner%2ecom%2fiwarranty%2fservlet%2fcom%2efourcs%2eclm%2eiwarranty%2esecurity%2eUserSignOffServlet');
            }
        }

        // Add an event listener that will execute the sendMessage() function
        // when the send button is clicked.
        // btn.addEventListener('click', sendMessage);
        
        document.getElementById('fb_iframe').onload = function() {
            var iframe = document.getElementById("fb_iframe");
            var elmnt = iframe.contentWindow.document.getElementById("USER");
            console.log(iframe);
            elmnt.value = 'D70SHM16';
            var elmnt1 = iframe.contentWindow.document.getElementById("PASSWORD");
            elmnt1.value = 'Truck17!';

            var elmnt2 = iframe.contentWindow.document.getElementById("subButt");
            elmnt2.click();
        }
            // $(document).ready(function() {
            //     $('iframe#fb_iframe').contents().find('#USER').val('D70SHM16');
            //     $('iframe#fb_iframe').contents().find('#PASSWORD').val('Truck17!');
            //     $('iframe#fb_iframe').contents().find('#subButt').click();
            // })

            // myframe.document.getElementById("USER").value = 'D70SHM16';
            // myframe.document.getElementById("PASSWORD").value = 'Truck17!';
            // myframe.document.getElementById("subButt").submit();

            // $("#USER").val('D70SHM16');
        
            // $("#PASSWORD").val('Truck17!');
            // $("#subButt").click();
        // },1000);
        
    },
    methods:{
        // UrlExist:function('chrome://extensions/?id=iahmjcnljmkbnbhmeonenpbfikdejmjo',function(status){

        //     if(status == 200){
        //         console.log('exist');
        //     }
        // });
        
    }
}
</script>




// WEBPACK FOOTER //
// src/components/OwlWarranty.vue